import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../auth.service';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';
import { FatalErrorService } from '../../services/fatal-error.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent {
  status?: number;
  message?: string;
  portalSupportUrl = environment.portalSupportUrl;
  isKeyCloakError?: boolean;

  constructor(private router: Router, private authService: AuthService, private fatal: FatalErrorService, private location: Location) {
    const navState = this.router.getCurrentNavigation()?.extras?.state as any;
    const svc = this.fatal.details;
    const hist = this.location.getState() as any;
  
    this.status = navState?.status ?? svc?.status ?? hist?.status;
    this.isKeyCloakError = navState?.isKeyCloakError ?? svc?.isKeyCloakError ?? hist?.isKeyCloakError;
  }

  get resolvedMessage(): string {
    switch (this.status) {
      case 0:   return 'We can’t reach the server. Check your connection or try again later.';
      case 500: return 'A system error occurred. Please try again later or contact support.';
      default:  return 'We can’t load required services right now. Please try again later or contact support.';
    }
  }

  openSupport() {
    window.open(this.portalSupportUrl, '_blank', 'noopener');
  }

  logout() {
    this.authService.logout();
  }
}


